import React, { useRef } from 'react';
import { Menu } from 'primereact/menu';
import { useTranslation } from 'react-i18next';
import { IProduct } from '../../../../InvoiceCreation/types/types';
import Button from '../../../../../../generic-components/Button';
import { ReactComponent as MoreIcon } from '../../../../../../assets/svg/invoices-icons/icon-three-dots.svg';
import { ReactComponent as DeleteIcon } from '../../../../../../assets/icons/svg/shared/ic-shared-trash.svg';
import { ReactComponent as EditIcon } from '../../../../../../assets/svg/edit_pen_icon.svg';
import { TEXTS } from '../../constants';

export const priceTemplate = (
  product: IProduct,
  onMenuClick: (menuRef: any, event: any) => void,
  onEditClick: () => void,
  onDeleteClick: () => void,
  allowEdit: boolean,
) => {
  const { t } = useTranslation();
  const menuRef: any | null = useRef(null);
  const menuItems = [
    {
      id: '0',
      label: t(TEXTS.SERVICES_AND_PRODUCTS_HUB.ITEM_MENU.EDIT_ITEM_BUTTON),
      className: 'py-[2px] font-metricR text-[14px] text-bw08',
      command: onEditClick,
      icon: <EditIcon className='mr-[4px]' />,
    },
    {
      id: '1',
      label: t(TEXTS.SERVICES_AND_PRODUCTS_HUB.ITEM_MENU.DELETE_ITEM_BUTTON),
      className: 'py-[2px] font-metricR text-[14px] text-bw08',
      command: onDeleteClick,
      icon: <DeleteIcon className='mr-[4px] w-[18px[ h-[18px] text-bw07' />,
    },
  ];
  return (
    <div className='flex items-center justify-between'>
      <span className='font-metricR text-[16px] text-bw08'>{`$${product.amount.toFixed(2)}`}</span>
      <div className='relative mr-[20px]'>
        <Menu popup model={menuItems} ref={menuRef} className='p-0 max-w-[164px]' id='menu_popup' />
        {allowEdit && (
          <Button
            className='hover:bg-bw03 rounded-sm'
            id='menu_button'
            childElement={<MoreIcon className=' ' />}
            onClick={(event) => onMenuClick(menuRef.current, event)}
          />
        )}
      </div>
    </div>
  );
};
